import CryptoJS from 'crypto-js';

const STORAGE_SECRET = 'ygsiahndCieqtkeresimsrcattoersmaigutiubliyellaueprtnernar';

const SESSION_KEYS = [
  'isLogedin', 'Name', 'Employee Code', 'Email', 'User Type',
  'ProfilePic', 'Status', 'Id', 'claimedRequirements', 'authToken',
];

export const encryptData = (data) => {
  let dataString = '';
  if (data === null || data === undefined) {
    dataString = '';
  } else if (typeof data === 'string') {
    dataString = data;
  } else {
    dataString = JSON.stringify(data);
  }
  return CryptoJS.AES.encrypt(dataString, STORAGE_SECRET).toString();
};

export const decryptData = (encryptedData) => {
  if (!encryptedData) return '';
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, STORAGE_SECRET);
    const decoded = bytes.toString(CryptoJS.enc.Utf8);
    return decoded || '';
  } catch {
    return '';
  }
};

export const getDecryptedData = (key) => {
  const encryptedData = localStorage.getItem(key);
  if (!encryptedData) return null;
  const value = decryptData(encryptedData);
  return value === '' ? null : value;
};

export const setEncryptedItem = (key, value) => {
  localStorage.setItem(key, encryptData(value ?? ''));
};

export const clearSession = () => {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const getAuthToken = () => getDecryptedData('authToken');

export const getUserType = () => getDecryptedData('User Type');

export const isValidSession = () => {
  const login = getDecryptedData('isLogedin');
  const userType = getUserType();
  const token = getAuthToken();
  return login === 'true' && !!token && ['Admin', 'TeamLead', 'User'].includes(userType);
};

export const saveLoginSession = (userData, token) => {
  clearSession();
  setEncryptedItem('isLogedin', 'true');
  setEncryptedItem('authToken', token || '');
  setEncryptedItem('Name', userData.EmployeeName || '');
  setEncryptedItem('Employee Code', userData.EmpCode || '');
  setEncryptedItem('Email', userData.Email || '');
  setEncryptedItem('User Type', userData.UserType || '');
  setEncryptedItem('ProfilePic', userData.ProfilePic || '');
  setEncryptedItem('Status', userData.Status || '');
  setEncryptedItem('Id', userData.Id ? String(userData.Id) : '');
  setEncryptedItem('claimedRequirements', userData.ClaimedRequirements || []);
};

export const logoutSession = () => {
  clearSession();
  window.location.href = '/';
};

export const redirectAfterLogin = () => {
  window.location.href = '/dashboard';
};

export const buildFallbackUser = () => ({
  _id: getDecryptedData('Id') || 'session',
  EmployeeName: getDecryptedData('Name') || 'User',
  Email: getDecryptedData('Email') || '',
  ProfilePic: getDecryptedData('ProfilePic') || '',
  UserType: getUserType() || 'User',
});
